import VimeoPlayer from './VimeoPlayer';

export default VimeoPlayer;
